import { Stack, TextField, Typography } from "@mui/material";

export default function DateRangeFilterRow({ dateRange, onChange }) {
  const isInverted =
    dateRange.from && dateRange.to && dateRange.to < dateRange.from;

  const styles = {
    row: { py: 0.75 },
    label: {
      flex: "0 0 130px",
      pt: 1.5,
      fontWeight: 700,
      fontSize: "0.7rem",
      color: "background.tableHeaderText",
      textTransform: "uppercase",
      letterSpacing: "0.07em",
    },
    input: { width: 160 },
    hint: {
      alignSelf: "flex-end",
      color: "background.tableHeaderText",
      fontSize: "0.75rem",
    },
  };

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      spacing={1.5}
      sx={styles.row}
    >
      <Typography sx={styles.label}>Time Period</Typography>
      <Stack direction="row" spacing={1.5} alignItems="flex-end">
        <TextField
          type="date"
          size="small"
          label="From"
          value={dateRange.from}
          onChange={(e) => onChange({ ...dateRange, from: e.target.value })}
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: dateRange.to ? { max: dateRange.to } : undefined,
          }}
          sx={styles.input}
        />
        <TextField
          type="date"
          size="small"
          label="To"
          value={dateRange.to}
          onChange={(e) => onChange({ ...dateRange, to: e.target.value })}
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: dateRange.from ? { min: dateRange.from } : undefined,
          }}
          sx={styles.input}
        />
        {isInverted && (
          <Typography sx={styles.hint}>
            Nothing to show for that range — start date is after end date.
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
